'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPriceAmountByCurrency = exports.isPriceHidden = exports.isNegotiable = exports.getAmount = exports.getNegotiable = exports.getHidePrice = undefined;

var _createSelector = require('./utils/createSelector');

var _createSelector2 = _interopRequireDefault(_createSelector);

var _makeSelectorHelpers = require('./utils/makeSelectorHelpers');

var _amount = require('./amount');

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Base Getters
// ------------------------------------------

var getHidePrice = exports.getHidePrice = function getHidePrice(price) {
  return (0, _lodash2.default)(price, 'hidePrice');
};
var getNegotiable = exports.getNegotiable = function getNegotiable(price) {
  return (0, _lodash2.default)(price, 'negotiable');
};
var getAmount = exports.getAmount = function getAmount(price) {
  return (0, _lodash2.default)(price, 'amount', {});
};

// Selectors
// ------------------------------------------

var isNegotiable = exports.isNegotiable = (0, _makeSelectorHelpers.makeYesCheckSelector)(getNegotiable);
var isPriceHidden = exports.isPriceHidden = (0, _makeSelectorHelpers.makeYesCheckSelector)(getHidePrice);
var getPriceAmountByCurrency = exports.getPriceAmountByCurrency = (0, _createSelector2.default)(getAmount, _amount.getAmountByCurrency);


//////////////////
// WEBPACK FOOTER
// ./~/dibs-display-helpers/~/dibs-selectors/dist/price.js
// module id = 2083
// module chunks = 64